import React, { useState, useCallback } from 'react';
import i18next from 'i18next';
import OptionBox from '../../../StyledComponents/OptionBox';
import { OptionBoxHeading, OptionBoxContent } from '../../../StyledComponents/OptionBox/wrapper';
import { UtilityTextPrimary } from '../../../StyledComponents/Utility';
import { ButtonInline } from '../../../StyledComponents/Button';
import { numberSeparator } from '../../../utils/formats';
import Modal from '../../../StyledComponents/Modal';
import { Image, ModalFoldout, ModalFoldoutBody } from '../../../StyledComponents/Modal/wrapper';
import Content from '../../../StyledComponents/Content';
import DataList from '../../../StyledComponents/DataList';
import { FinancialOption } from '../../../@types/codegen/types';
import { marked } from 'marked';

interface LeasingProps {
  financialOption: FinancialOption;
}

const Leasing = ({ financialOption }: LeasingProps) => {
  const [modal, setModal] = useState(false);
  const toggleModal = useCallback(() => setModal(!modal), [modal]);

  const { image, description, monthlyCost, duration, mileage, type, name } = financialOption;

  const title =
    type === 'leasing'
      ? i18next.t('item.financialOptions.privateLease')
      : type === 'business-leasing'
      ? i18next.t('item.financialOptions.businessLease')
      : type;

  return (
    <>
      {modal && (
        <Modal title={title} onClose={toggleModal}>
          {image && <Image src={image} alt={title} />}
          {description && <Content dangerouslySetInnerHTML={{ __html: marked(description) }} />}
          <ModalFoldout>
            <ModalFoldoutBody>
              <DataList
                items={[
                  {
                    label: i18next.t('item.financialOptions.monthlyCost'),
                    value: `${numberSeparator(monthlyCost || 0)} ${i18next.t('currency.monthly')}`,
                  },
                  {
                    label: i18next.t('item.financialOptions.bindingTime'),
                    value: `${duration?.current} ${i18next.t('common.months').toLowerCase()}`,
                  },
                  {
                    label: i18next.t('item.financialOptions.annualMileage'),
                    value: `${numberSeparator(mileage?.current || 0)} ${i18next.t(
                      'odometer.defaultYearly'
                    )}`,
                  },
                ]}
              />
            </ModalFoldoutBody>
          </ModalFoldout>
        </Modal>
      )}
      <OptionBox>
        <>
          {monthlyCost !== null && monthlyCost !== undefined && (
            <OptionBoxHeading>{`${numberSeparator(monthlyCost)} ${i18next.t(
              'currency.monthly'
            )}`}</OptionBoxHeading>
          )}
        </>
        <OptionBoxContent>
          <p>
            {title}{' '}
            {mileage?.current && duration?.current && (
              <>
                <UtilityTextPrimary>
                  {numberSeparator(mileage?.current)} ${i18next.t('odometer.defaultYearly')}
                </UtilityTextPrimary>{' '}
                i{' '}
                <UtilityTextPrimary>
                  {duration?.current} {i18next.t('common.monthUnitShort')}
                </UtilityTextPrimary>
                .{' '}
              </>
            )}
          </p>
          {name && (
            <p>
              <ButtonInline onClick={toggleModal} title={i18next.t('common.readMore') || ''}>
                {i18next.t('common.readMore')}
              </ButtonInline>
            </p>
          )}
        </OptionBoxContent>
      </OptionBox>
    </>
  );
};

export default Leasing;
